import { render, staticRenderFns } from "./Solve.vue?vue&type=template&id=7a6526a0&scoped=true"
import script from "./Solve.vue?vue&type=script&lang=js"
export * from "./Solve.vue?vue&type=script&lang=js"
import style0 from "./Solve.vue?vue&type=style&index=0&id=7a6526a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6526a0",
  null
  
)

export default component.exports